/**
 * Defines the unit for a miscellaneous fee.
 * tag: 891
 * @readonly
 * @enum {number} (int)
 */
export enum MiscFeeBasis {
  Absolute = 0,
  PerUnit = 1,
  Percentage = 2,
}
